var SpriteSymbol = require("../../../../../nike-mobile/node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../nike-mobile/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "arrow-sl",
  "use": "arrow-sl-usage",
  "viewBox": "0 0 10 6",
  "content": "<symbol viewBox=\"0 0 10 6\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-sl\"><path fillRule=\"evenodd\" d=\"M9.313.784a.675.675 0 0 1 0 .96L5.444 5.535a.69.69 0 0 1-.97 0L.605 1.744a.674.674 0 0 1 0-.96.69.69 0 0 1 .969 0l3.385 3.109L8.344.784a.69.69 0 0 1 .969 0z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id